import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function CookiePolicyPage() {
  useMetaTags({
    title: 'Cookie Policy | FindOnlineDegrees',
    description: 'Learn how FindOnlineDegrees uses cookies and similar technologies to support site functionality, analytics, and your preferences.'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1582" data-mp="1fd2j872ytyk4">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1583" data-mp="1kbvml6ojg96k">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1584" data-mp="1kdqbew2xklfx">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1585" data-mp="1p95hh1up5d1s">Cookie Notice</h1>
          <p className="text-gray-300 text-sm" data-id="element-1586" data-mp="1u9a2n56juvyc">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1587" data-mp="1yac29n4dpa0u">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1588" data-mp="3w1ohtwhplmb2">
          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1589" data-mp="3wucdtgi412n">
            <p data-id="element-1590" data-mp="3z6se12p81d2">
              This Cookie Notice explains how FindOnlineDegrees.org uses cookies
              and similar technologies to recognize you when you visit our
              website. It explains what these technologies are, why we use them,
              and your rights to control our use of them.
            </p>
          </div>

          {/* What Are Cookies */}
          <div data-id="element-1591" data-mp="2wq2pahhe5ziw">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1592" data-mp="2wmeuzg44h934">
              1. WHAT ARE COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1593" data-mp="3pd705336182l">
              <p data-id="element-1594" data-mp="3pdyivdbnzbbg">
                Cookies are small data files placed on your device when you
                visit a website. Cookies are widely used to make websites work
                more efficiently and to provide reporting information.
              </p>
              <p data-id="element-1595" data-mp="28z707s4blifc">
                Cookies set by the website owner (in this case,
                FindOnlineDegrees.org) are called "first-party cookies." Cookies
                set by parties other than the website owner are called
                "third-party cookies." Third-party cookies enable features or
                functionality such as advertising, analytics, and interactive
                content.
              </p>
            </div>
          </div>

          {/* Why Do We Use Cookies */}
          <div data-id="element-1596" data-mp="r092zmgfvkou">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1597" data-mp="qzqwzy3z5s3q">
              2. WHY DO WE USE COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1598" data-mp="caba4t7ke6tb">
              <p data-id="element-1599" data-mp="h3xlmi1zs4nj">
                We use first-party and third-party cookies for several reasons:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1600" data-mp="3dkg0mckp21d">
                <li data-id="element-1601" data-mp="8a15pkzf7ogk">
                  <strong data-id="element-1602" data-mp="8bm09alqj7ef">Essential cookies:</strong> Required for technical
                  operation of our website (e.g., account login, security).
                </li>
                <li data-id="element-1603" data-mp="3uiagab4odnme">
                  <strong data-id="element-1604" data-mp="3ugpminq6q8pl">Performance and analytics cookies:</strong> Collect
                  information to help us understand website performance and
                  improve user experience.
                </li>
                <li data-id="element-1605" data-mp="36wgkzaq8xv7j">
                  <strong data-id="element-1606" data-mp="36x02wrfwcjlk">Advertising cookies:</strong> Deliver relevant ads and
                  measure effectiveness of our marketing campaigns.
                </li>
                <li data-id="element-1607" data-mp="3ftqx0yaw1odi">
                  <strong data-id="element-1608" data-mp="3fxeta57pwovx">Functionality cookies:</strong> Remember your
                  preferences and settings.
                </li>
              </ul>
            </div>
          </div>

          {/* Types of Cookies */}
          <div data-id="element-1609" data-mp="7fik0ykun66g">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1610" data-mp="7g1rflcvic68">
              3. TYPES OF COOKIES WE USE
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-1611" data-mp="2hqkbidyqfrp">
              <div data-id="element-1612" data-mp="hd6ju2xbb3vh">
                <h3 className="font-bold text-lg mb-2" data-id="element-1613" data-mp="hercfn02gcqp">
                  Strictly Necessary Cookies
                </h3>
                <p data-id="element-1614" data-mp="cg693epipcy1">
                  These are essential to provide services and cannot be switched
                  off. They are usually only set in response to actions you
                  take, such as setting privacy preferences or filling in forms.
                </p>
              </div>

              <div data-id="element-1615" data-mp="2fnndp236y8p8">
                <h3 className="font-bold text-lg mb-2" data-id="element-1616" data-mp="2fphqtu880wir">
                  Analytics and Performance Cookies
                </h3>
                <p data-id="element-1617" data-mp="1myzq2zuyz78i">
                  Help us count visits, traffic sources, and measure site
                  performance. Examples include Google Analytics cookies. These
                  cookies allow us to know which pages are most and least
                  popular and see how visitors move around the site.
                </p>
              </div>

              <div data-id="element-1618" data-mp="21x1sh6q9lmo6">
                <h3 className="font-bold text-lg mb-2" data-id="element-1619" data-mp="38bt2bzxd8huc">Advertising Cookies</h3>
                <p data-id="element-1620" data-mp="38dx3wb7sl4rg">
                  Used by us and third parties (such as Google Ads, Bing Ads, or
                  other ad networks) to build a profile of your interests and
                  show you relevant ads on other sites. They work by uniquely
                  identifying your browser and device.
                </p>
              </div>

              <div data-id="element-1621" data-mp="rwz5u86rch6d">
                <h3 className="font-bold text-lg mb-2" data-id="element-1622" data-mp="rwfwvgz3534h">
                  Functionality Cookies
                </h3>
                <p data-id="element-1623" data-mp="mye3o37y3nfa">
                  Enable enhanced functionality and personalization, such as
                  remembering your preferences. They may be set by us or by
                  third-party providers whose services we use on our pages.
                </p>
              </div>
            </div>
          </div>

          {/* How to Control Cookies */}
          <div data-id="element-1624" data-mp="40lee3q8vc0d">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1625" data-mp="413fperrkgf5">
              4. HOW CAN YOU CONTROL COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1626" data-mp="23atfo7ezesdn">
              <p data-id="element-1627" data-mp="1yf4btrvxipbj">
                You have the right to decide whether to accept or reject
                cookies. You can exercise your cookie preferences through your
                browser settings:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1628" data-mp="1hgkbx6wu1zy">
                <li data-id="element-1629" data-mp="3iwn3akqy71s8">
                  <strong data-id="element-1630" data-mp="3ixewjox2onfc">Browser Controls:</strong> Most web browsers allow you
                  to control cookies through their settings. However, if you
                  limit the ability of websites to set cookies, you may worsen
                  your overall user experience.
                </li>
                <li data-id="element-1631" data-mp="kdpwug25ykhu">
                  <strong data-id="element-1632" data-mp="kbvkvr8ve2pw">Opt-Out Links:</strong> You can opt out of the
                  collection and use of information for interest-based
                  advertising through the industry opt-out pages below. Each
                  page lets you see which participating companies are using
                  your information and turn off ad targeting for them:
                  <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-1633" data-mp="2v72jjzmz00hw">
                    <li data-id="element-1634" data-mp="1d84r07a1aqxq">
                      Digital Advertising Alliance (US):{' '}
                      <a href="http://www.aboutads.info/choices" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] underline hover:no-underline" data-id="element-1635" data-mp="189thjxnniig1">
                        aboutads.info/choices
                      </a>
                    </li>
                    <li data-id="element-1636" data-mp="ufsewstkwbae">
                      European Interactive Digital Advertising Alliance:{' '}
                      <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] underline hover:no-underline" data-id="element-1637" data-mp="ph8vp06dddlq">
                        youronlinechoices.eu
                      </a>
                    </li>
                    <li data-id="element-1638" data-mp="6sc10v728j2z">
                      Network Advertising Initiative:{' '}
                      <a href="https://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] underline hover:no-underline" data-id="element-1639" data-mp="voxu5r5yse1e">
                        optout.networkadvertising.org
                      </a>
                    </li>
                    <li data-id="element-1640" data-mp="1elfpsjnxoy2x">
                      Meta (Facebook and Instagram) ad preferences:{' '}
                      <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] underline hover:no-underline" data-id="element-1641" data-mp="1jk0r6mex9nsy">
                        facebook.com/settings?tab=ads
                      </a>
                    </li>
                  </ul>
                </li>
                <li data-id="element-1642" data-mp="229gu1ge2xscj">
                  <strong data-id="element-1643" data-mp="2cg9pwhdrb9qr">Do Not Track:</strong> Some browsers have a "Do Not
                  Track" feature that lets you tell websites you do not want to
                  have your online activities tracked.
                </li>
              </ul>
            </div>
          </div>

          {/* Third-Party Cookies */}
          <div data-id="element-1644" data-mp="1yh0myjekac4q">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1645" data-mp="1yhjst1qxta2e">
              5. THIRD-PARTY COOKIES
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1646" data-mp="2v8c9o1lp3658">
              <p data-id="element-1647" data-mp="2q8g43xxcn6nk">
                We use pixels, web beacons, cookies, and other storage
                technologies from third parties, including Meta (Facebook), to
                collect or receive information from our websites and elsewhere
                on the internet. Those third parties, including Meta, use that
                information to provide measurement services, and to target and
                deliver advertising to you on their own and other platforms.
                Common third-party services include:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1648" data-mp="mvmsa8vva5ob">
                <li data-id="element-1649" data-mp="mx7kvsymfejj">Google Analytics (analytics and performance)</li>
                <li data-id="element-1650" data-mp="10vnzs76n0bcr">Google Tag Manager (tag and tracking management)</li>
                <li data-id="element-1651" data-mp="vwkuqmqnq54s">Google Ads (advertising)</li>
                <li data-id="element-1652" data-mp="vurmx44b5ev7">Bing Ads (advertising)</li>
                <li data-id="element-1653" data-mp="1atllamx43u1o">
                  Meta Pixel and Conversions API (advertising, matching, and
                  measurement)
                </li>
              </ul>
              <p data-id="element-1654" data-mp="15u8trovapysr">
                To stop the collection and use of this information for ad
                targeting, use the opt-out mechanisms listed in Section 4
                above.
              </p>
            </div>
          </div>

          {/* Updates to This Notice */}
          <div data-id="element-1655" data-mp="1tkl7jgd82pr9">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1656" data-mp="1tkcwzv4knwj8">
              6. UPDATES TO THIS COOKIE NOTICE
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1657" data-mp="2871r1hg21hi8">
              <p data-id="element-1658" data-mp="284pbtc1oll8v">
                We may update this Cookie Notice from time to time to reflect
                changes in the cookies we use or for other operational, legal,
                or regulatory reasons. Please revisit this Cookie Notice
                regularly to stay informed about our use of cookies.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1659" data-mp="1pe7mlhg257s9">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1660" data-mp="1peg2li7h8t7o">
              7. CONTACT US
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1661" data-mp="1ficy45p5kihk">
              <p data-id="element-1662" data-mp="1fg09j9ow39vj">
                If you have questions about our use of cookies or this Cookie
                Notice, please contact us through the information provided on
                our website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}